import React, {Component} from "react";
import styled from "styled-components";

class OrderConfirmation extends Component {
  constructor(props) {
    super(props);
    
    if(this.props.label !== undefined){
      this.state = this.props.label;
      this.state.allowdisp = true;
    } else {
      this.state = {allowdisp: false};
    }
  }
  
  renderPackages(){
    let packages = [...this.state.packages].splice(1);
    
    return packages.map((pkg, index) => {
      let itemsText = pkg.goods_package.map(item => `${item.quantity}x ${item.goods_name}`).join(', ');
      
      return (
        <TableRow key={pkg.id_package}>
          <TableCol className="align-center">{index + 1}</TableCol>
          <TableCol>{pkg.name}</TableCol>
          <TableCol>{pkg.address}</TableCol>
          <TableCol className="align-center">{pkg.delivery_date.substring(0,10)}</TableCol>
          <TableCol>{itemsText}</TableCol>
        </TableRow>
      );
    });
  }
  
  render() {
    return (
      <OuterWrap>
        <Wrapper>
          {this.state.allowdisp &&
          <>
            <Header>
              <HeaderTitle>ORDER CONFIRMATION</HeaderTitle>
            </Header>
            
            <CustomerInfo>
              <InfoRow>
                <InfoLabel>Customer:</InfoLabel>
                <InfoValue>{this.state.customer.fullname}</InfoValue>
              </InfoRow>
              <InfoRow>
                <InfoLabel>No SPO:</InfoLabel>
                <InfoValue>{this.state.no_spo}</InfoValue>
              </InfoRow>
              {this.state.invoices.length > 0 && (
                <InfoRow>
                  <InfoLabel>No Invoice:</InfoLabel>
                  <InfoValue>{this.state.invoices[0].no_invoice}</InfoValue>
                </InfoRow>
              )}
            </CustomerInfo>

            <TableContents>
              <TableRow>
                <TableHeader>No</TableHeader>
                <TableHeader>Nama</TableHeader>
                <TableHeader>Alamat</TableHeader>
                <TableHeader>Delivery Date</TableHeader>
                <TableHeader>Items</TableHeader>
              </TableRow>
              {this.renderPackages()}
            </TableContents>
          </>
          }
        </Wrapper>
      </OuterWrap>
    );
  }
}

const OuterWrap = styled.div`
  
`;

const Wrapper = styled.div`
  display: block;
  position: relative;
  width: 14.8cm;  /* A5 width */
  height: 21cm;   /* A5 height */
  margin: 0 auto;
  padding: 1cm;
  font-family: Arial, sans-serif;
  font-size: 12px;
  line-height: 1.4;
  
  @page {
    size: A5;
    margin: 1cm;
  }
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 20px;
  border-bottom: 2px solid #000;
  padding-bottom: 10px;
`;

const HeaderTitle = styled.h1`
  font-size: 18px;
  font-weight: bold;
  margin: 0;
`;

const CustomerInfo = styled.div`
  margin-bottom: 20px;
`;

const InfoRow = styled.div`
  display: flex;
  margin-bottom: 5px;
`;

const InfoLabel = styled.div`
  width: 100px;
  font-weight: bold;
`;

const InfoValue = styled.div`
  flex: 1;
`;

const TableContents = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
`;

const TableRow = styled.tr`
  
`;

const TableHeader = styled.th`
  border: 1px solid #000;
  padding: 8px 4px;
  background-color: #f0f0f0;
  font-weight: bold;
  text-align: left;
  font-size: 10px;
`;

const TableCol = styled.td`
  border: 1px solid #000;
  padding: 6px 4px;
  vertical-align: top;
  font-size: 10px;
  
  &.align-center {
    text-align: center;
  }
`;

export default OrderConfirmation;